(function (pmw, undefined) {

	const PMW_LIBRARY_VERSION = "1.71.0"

	/**
	 * The pmwDataLayer schema version this library understands. Must match
	 * PMW_DATA_LAYER_SCHEMA_VERSION on the PHP side. Bumped manually, and
	 * only for BREAKING data layer changes; additive changes never bump it.
	 * A bump ships together with docs/schema/pmw-datalayer.schema.json, the
	 * fixtures, and the payload snapshots. See docs/PLATFORM-CONTRACT.md.
	 */
	const PMW_SCHEMA_VERSION = 1

	pmw.getLibraryVersion = () => {
		return PMW_LIBRARY_VERSION
	}

	pmw.getSchemaVersion = () => {
		return PMW_SCHEMA_VERSION
	}

	/**
	 * Compare this bundle against the version the server printed into the page.
	 *
	 * A mismatch means the browser executed a script file from an earlier
	 * release. The bundle loads its pixel code as webpack chunks whose file
	 * names change with every release, so the stale bundle then requests chunk
	 * names the installed release no longer ships and tracking breaks with a
	 * 404 plus a ChunkLoadError.
	 *
	 * The usual cause is not a stale page cache but a stale copy of the script
	 * file itself: an optimizer that strips the ?ver marker from the URL (for
	 * example LiteSpeed's "Remove Query Strings") leaves the browser and the
	 * CDN with a versionless URL they never revalidate.
	 */
	pmw.checkLibraryVersion = () => {

		if (pmw.getLibraryVersion() !== pmwDataLayer?.version?.number) {
			console.error(`Pixel Manager: this script file is version ${pmw.getLibraryVersion()}, but version ${pmwDataLayer?.version?.number} is installed on the server. The browser is running a cached copy from an earlier release, and loading the tracking code will most likely fail. Purge the browser, CDN and host caches, and check whether an optimization plugin removes query strings from script URLs, which strips the version marker the caches key on. See https://sweetcode.com/docs/pmw/caching-and-optimization`)
		}

		pmw.checkSchemaVersion()
	}

	/**
	 * Whether a failed dynamic import failed because the chunk file is gone.
	 *
	 * Webpack names the chunk files after a content hash, so every release
	 * ships a different set and the previous release's files stop existing.
	 * A browser running a library from an earlier release therefore asks for
	 * chunk names the installed release no longer has, the requests 404, and
	 * webpack raises a ChunkLoadError.
	 *
	 * This is the signal checkLibraryVersion() cannot give. That check compares
	 * the bundle against the version the same page printed, so it only speaks
	 * up when the script file is stale underneath a current page. When a cache
	 * serves the whole page from before the update, the page carries a stale
	 * version number too, the two agree, and the check stays quiet while the
	 * shop is just as broken. The failing import is the one moment where the
	 * staleness is undeniable, so that is where we name it.
	 */
	pmw.isStaleBundleError = ( error ) => {
		return error?.name === "ChunkLoadError"
	}

	/**
	 * Compare the data layer's schema version against the library's.
	 *
	 * - dataLayer NEWER than library: the server emits a shape this library
	 *   cannot fully read. Hard error + pmw:error:schema-mismatch bus event
	 *   so platform harnesses can report it.
	 * - dataLayer OLDER or missing: tolerated (schema bumps are breaking on
	 *   the emitting side, the library stays backward-compatible by policy);
	 *   a console warning aids diagnosis of stale caches.
	 */
	pmw.checkSchemaVersion = () => {

		const dataLayerSchema = pmwDataLayer?.version?.schema

		if (typeof dataLayerSchema === "undefined") {
			console.warn("Pixel Manager: The pmwDataLayer carries no schema version. The server side is probably older than the library; if tracking misbehaves, delete the server-side cache.")
			return
		}

		if (dataLayerSchema > PMW_SCHEMA_VERSION) {
			console.error(`Pixel Manager: The pmwDataLayer schema version ${dataLayerSchema} is newer than the library's (${PMW_SCHEMA_VERSION}). The tracking library is too old for this server; delete all caches, and if the mismatch persists, reinstall the plugin.`)
			pmw.bus.emit("pmw:error:schema-mismatch", {
				dataLayer: dataLayerSchema,
				library  : PMW_SCHEMA_VERSION,
			})
			return
		}

		if (dataLayerSchema < PMW_SCHEMA_VERSION) {
			console.warn(`Pixel Manager: The pmwDataLayer schema version ${dataLayerSchema} is older than the library's (${PMW_SCHEMA_VERSION}). Probably a stale server-side cache; the library stays backward-compatible.`)
		}
	}

}(window.pmw = window.pmw || {}))

